/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-events',
    'cookie-utils',
    'plugin.tooltip',
    'thd-cart-bindings',
    'pip-domain',
    '@thd-olt-global/thd-customer'
],
function(
    $,
    Mustache,
    pip,
    pipEvents,
    cookieUtils,
    tooltip,
    thdCartBindings,
    pipDomain,
    thdCustomer
){

    var view = {
      templates: {
          displayOptionEnabled: $("#instant_checkout_enabled").html(),
          displayOptionEdit: $("#instant_checkout_edit").html(),
          displayOptionEnroll: $("#instant_checkout_enroll").html(),
          displayOptionSignIn: $("#instant_checkout_signin").html(),
          instantCheckoutTooltip: $("#instant_checkout_tooltip").html(),
      },
      selectors: {
          instantCheckoutSettings: '#icInfoTooltipOpener',
          instantCheckoutATC: '#atc_instant_checkout',
          buybeltMerch: '#buybelt__instant_checkout_merch',
          assemblyCheckbox: 'input[name=assembly__checkbox]',
          attachLaborCheckbox: 'input[name=attach-labor__checkbox]',
          subscribeSaveRadio: 'input[name=subscribe-and-save-radio]',
          dualPathCheckbox: 'input[name=dual-path__checkbox]',
          subscribeSaveOptIn: '#subscribe-and-save-options__opt-in',
          signinRedirect: '#signin-redirect',
      },
      render: {
          displayOptionLayout: function displayOptionLayout(data){
              var displayOption = data.instantCheckoutModel ? data.instantCheckoutModel.displayOption : data;
              var IC = "IC";
              var ENROLL = "ENROLL";
              var EDIT_IC = "EDIT_IC";
              var SIGN_IN = "SIGN_IN";
              var DEFAULT = "DEFAULT";
              switch (displayOption) {
                case IC:
                      return Mustache.render(view.templates.displayOptionEnabled, data);
                case ENROLL:
                      return Mustache.render(view.templates.displayOptionEnroll, data);
                case EDIT_IC:
                      return Mustache.render(view.templates.displayOptionEdit, data);
                case SIGN_IN:
                      return Mustache.render(view.templates.displayOptionSignIn, data);
                case DEFAULT:
                  return Mustache.render(view.templates.displayOptionEnroll, data);
              }
          }
      },
      updateDOM: {
        displayOptionLayout: function instantCheckoutUpdateDOM(data) {
          $(view.selectors.buybeltMerch).html(view.render.displayOptionLayout(data));
        },
      },
      initInstantChekoutTooltip: function initInstantChekoutTooltip() {
        $(view.selectors.instantCheckoutSettings).tooltip({
          type: 'click',
          position: 'bottom',
          content: view.templates.instantCheckoutTooltip,
          width: 'medium',
          closeButton: true,
          bestPosition: false,
          closeOnClick: true
        });
      },
      init: function initView() {
          view.initInstantChekoutTooltip();
      },
    };
  var model = {
    fetch: {
      instantCheckoutModel: function instantCheckoutModel(){
        return $.ajax({
          type: "GET",
          url: "/p/svcs/instantCheckoutModel",
          timeout: 10000,
          dataType: "json",
          cache: false
        })
      }
    }
  }

  function isItemInventoryAvail() {
    return !!(pip
      && pip.inventory
      && pip.inventory.online
      && pip.inventory.online.isInStock)
  }
  function isShipToHome() {
    return !!(pip
      && pip.fulfillment
      && pip.fulfillment.shipping
      && pip.fulfillment.shipping.shipToHome);
  }

  function userSessionValid() {
    var hasUserID = pip.customer.hasUserID();
    var hasUserSession = pip.customer.hasUserSession();
    var isLoggedIn = pip.customer.isLoggedIn();
    var isTwoFactorAuth = pip.customer.isTwoFactorAuth();
    return (hasUserID && !hasUserSession && !isTwoFactorAuth) || (isLoggedIn && isTwoFactorAuth);
  }

  function isB2CCustomer() {
    if (pip.features.thdCustomerCookieEnabled) {
      return thdCustomer.default.isB2CCustomer;
    } else {
      var customerCookie = cookieUtils.parseJWTCookie('THD_CUSTOMER');
      var customerType = customerCookie && customerCookie.c;
      return !(customerType === "B2B" || customerType === "B2X");
    }
  }

  function isInstantCheckoutEligible() {
    return !!(pip.features.instantCheckoutFeatureEnabled
      && isShipToHome()
      && isItemInventoryAvail()
      && userSessionValid()
      && isB2CCustomer()
    );
  }
  function isGuestInstantCheckoutEligible() {
    return !!(pip.features.instantCheckoutFeatureEnabled
      && isShipToHome()
      && isItemInventoryAvail()
      && isB2CCustomer()
    );
  }
  function getProReferralCategory() {
    if(pip.serviceAddOns && pip.serviceAddOns.proReferral) {
      return pip.serviceAddOns.proReferral.category;
    }
    return '';
  }
   function getInstantCheckoutAtcRequest() {
     var mccAtcRequest = {
      itemId: pip.products.primary.data.itemId,
      quantity: pip.customer.quantity,
      fulfillmentMethod: 'ShipToHome',
      fulfillmentLocation: 'DirectShip',
     };
     if (pip.customer.isOptedIntoHdpp && pip.protectionPlan) {
       mccAtcRequest.warrantyItem = {
         itemId: pip.protectionPlan.itemId
       }
     }
     if (pip.customer.isOptedIntoProReferral) {
       mccAtcRequest.service = {
         type: getProReferralCategory(),
         selected: true
       }
     }
     return mccAtcRequest;
   }
  function initEventListeners() {
      $(document).off('.instantCheckout');
      $(document).on('click.instantCheckout', view.selectors.signinRedirect, function callback(e) {
         var redirect = window.top.location.href.replace(window.top.location.origin, '');
         window.location.href='/auth/view/signin?redirect=' + redirect;
      });
      $(document).on('click.instantCheckout', view.selectors.instantCheckoutATC, function callback(e) {
        var instantCheckoutAddToCartRequest = getInstantCheckoutAtcRequest();
          thdCartBindings.instantCheckout(instantCheckoutAddToCartRequest, {
              host: pipDomain.getDomain(),
              channel: pip.platform.toLowerCase(),
          });
      });
      $(document).on('change.instantCheckout', view.selectors.assemblyCheckbox, function() {
        if(isIneligibleAddOns()) {
          $(view.selectors.instantCheckoutATC).prop('disabled', true);
        } else {
          $(view.selectors.instantCheckoutATC).prop('disabled', false);
        }
      });
      $(document).on('change.instantCheckout', view.selectors.attachLaborCheckbox, function() {
        if(isIneligibleAddOns()) {
          $(view.selectors.instantCheckoutATC).prop('disabled', true);
        } else {
          $(view.selectors.instantCheckoutATC).prop('disabled', false);
        }
      });
      $(document).on('change.instantCheckout', view.selectors.subscribeSaveRadio, function() {
        if(isIneligibleAddOns()) {
          $(view.selectors.instantCheckoutATC).prop('disabled', true);
        } else {
          $(view.selectors.instantCheckoutATC).prop('disabled', false);
        }
      });
      $(document).on('change.instantCheckout', view.selectors.dualPathCheckbox, function() {
        if(isIneligibleAddOns()) {
          $(view.selectors.instantCheckoutATC).prop('disabled', true);
        } else {
          $(view.selectors.instantCheckoutATC).prop('disabled', false);
        }
      });
  }
  function isIneligibleAddOns() {
    return (
      $(view.selectors.subscribeSaveOptIn).is(':checked') ||
      $(view.selectors.assemblyCheckbox).is(':checked') ||
      $(view.selectors.attachLaborCheckbox).is(':checked') ||
      $(view.selectors.dualPathCheckbox).is(':checked')
    );
  }
  return {
    init: function init() {
          if (isInstantCheckoutEligible()) {
            model.fetch.instantCheckoutModel().done(
              function (data) {
                view.updateDOM.displayOptionLayout(data);
                view.init();
                initEventListeners();
                if (data.instantCheckoutModel.displayOption === "IC") {
                  pipEvents.instantCheckout.instantCheckoutAnalytics.trigger();
                }
              }
            ).fail(function(xhr, status, error) {
              var errorStatus = xhr.status
              if(pip.debugMode) {
                console.error('instant checkout  xhr: ' + errorStatus);
              }
            })
          } else if (isGuestInstantCheckoutEligible()) {
            view.updateDOM.displayOptionLayout('DEFAULT');
            view.init();
            initEventListeners();
          }
        },
        view: view,
        model: model,
        isShipToHome: isShipToHome,
        isItemInventoryAvail: isItemInventoryAvail,
        isInstantCheckoutEligible: isInstantCheckoutEligible,
        isGuestInstantCheckoutEligible: isGuestInstantCheckoutEligible,
      }
});

}.call(window));